import Badge from 'molecules/Badge';
import Button from 'molecules/Button';
import Image from 'molecules/Image';
import Link from 'molecules/Link';

import { hasArrayValues } from 'utils/array/arrays';

import type { FC } from 'react';

interface FeaturedResourceCardProps extends BlogResource {
  featuredVideoThumbnail?: CloudinaryImageProps;
  openGraphImage?: CloudinaryImageProps;
}

const FeaturedResourceCard: FC<FeaturedResourceCardProps> = ({
  url,
  featuredImage,
  featuredVideoThumbnail,
  openGraphImage,
  tags,
  title,
  summary,
}) => (
  <Link
    href={url}
    aria-label={title}
    className="dark group grid h-full grid-cols-1 rounded-lg border border-primary-300 bg-gray-900/40  p-4 backdrop-blur focus-outline-primary md:grid-cols-12"
    enablePreview={false}
  >
    {(featuredImage || featuredVideoThumbnail || openGraphImage) && (
      <div className="w-full md:col-span-5">
        <Image
          {...(featuredImage?.file ? featuredImage.file : featuredImage || featuredVideoThumbnail || openGraphImage)}
          unsetRatio
          objectCover
          className="aspect-video size-full overflow-hidden rounded-lg md:aspect-auto"
          alt={
            featuredImage?.alt ||
            featuredImage?.display_name ||
            openGraphImage?.alt ||
            openGraphImage?.display_name ||
            'Image for featured resource'
          }
          url={featuredImage?.file?.url || featuredVideoThumbnail?.file?.url || openGraphImage?.file?.url}
        />
      </div>
    )}
    <div className="flex flex-col gap-4 px-4 py-6 text-left md:col-span-7">
      {hasArrayValues(tags) && (
        <div className="flex flex-wrap gap-4">
          {hasArrayValues(tags) && (
            <>
              {tags.slice(0, 2).map(tag => (
                <Badge key={tag} label={tag} color="gray" />
              ))}
              {tags.length > 2 && (
                <Badge label={`+${tags.length - 2} ${tags.length - 2 === 1 ? 'more' : 'others'}`} color="gray" />
              )}
            </>
          )}
        </div>
      )}
      {title && (
        <h3 className="font-spaceGrotesk text-display-xs font-semibold text-white lg:text-display-sm">{title}</h3>
      )}
      {summary && <p className="line-clamp-3 text-white sm:line-clamp-none">{summary}</p>}
      {url && (
        <Button
          hierarchy="linkGray"
          endIcon="arrow-up-right"
          label="Read more"
          semanticFallback="div"
          className="w-fit"
        />
      )}
    </div>
  </Link>
);

export default FeaturedResourceCard;
